import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Company, CompanyRoles } from '../../_models/company.model';
import { DataPersistenceService } from '../data-persistence/data-persistence.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  private apiUrl = environment.urlApi+'/registro';

  constructor(private http: HttpClient, private dataPersistenceService: DataPersistenceService) {}

  getExternalReferences(): Observable<Company> {
    let usernameNumber = this.dataPersistenceService.getCompanyIdCookie();
    if (usernameNumber == null) {
      usernameNumber = this.dataPersistenceService.getCompanyIdCookieIdEmpresa();
    }
    const origin = 'scm';

    // Si no hay usernameNumber, es una ruta pública - retornar Observable vacío
    if (usernameNumber == '' || usernameNumber == null) {
      return new Observable((observer) => {
        observer.next({} as Company);
        observer.complete();
      });
    }

    const getUsername = this.dataPersistenceService.getCompanyIdAndUsernameCookie();
    const username = getUsername.split("_")[0];

    const url = `${this.apiUrl}/Companies/externalreferences/${origin}/${usernameNumber}/${username}`;

    return this.http.get<Company>(url).pipe(
      tap((response) => {
        if (response && response.id) {
          this.dataPersistenceService.setIdentificationNumberCookie(response.identification_number);
          this.dataPersistenceService.setCompanyIdCookie(response.id);
          this.dataPersistenceService.setRoles(response.roles);
        } else {
          console.error('No se encontró el campo companyId en la respuesta.');
        }
      }),
      catchError(this.handleError)
    );
  }








  private handleError(error: any): Observable<never> {
    console.error('Error en la solicitud HTTP:', error);
    let errorMessage =
      'Ocurrió un error, por favor inténtelo de nuevo más tarde.';

    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente
      errorMessage =
        'Error de conexión. Por favor, verifique su conexión a internet.';
    } else if (error.status === 401) {
      errorMessage =
        'Su sesión ha expirado. Por favor, inicie sesión nuevamente.';
    } else if (error.status === 403) {
      errorMessage = 'No tiene permisos para realizar esta acción.';
    } else if (error.status === 404) {
      errorMessage = 'No se encontró el recurso solicitado.';
    } else if (error.status >= 500) {
      errorMessage = 'Error del servidor. Por favor, inténtelo más tarde.';
    }

    return throwError(() => new Error(errorMessage));
  }

  // checkAndRegister(
  //   companyId: string,
  //   identificationNumber: string
  // ): Observable<any> {
  //   const params = new HttpParams({
  //     fromObject: {
  //       companyId,
  //       subcontractorIdentificationNumber: identificationNumber,
  //     },
  //   });

  //   return this.http
  //     .post(
  //       `${this.apiUrl}/Registers/checkandregister`,
  //       {},
  //       {
  //         params,
  //         headers: {
  //           'X-Skip-Snackbar': 'true',
  //         },
  //       }
  //     )
  //     .pipe(
  //       catchError((error) => {
  //         console.error('❌ Error en la llamada:', error);
  //         return throwError(() => error);
  //       })
  //     );
  // }

}
